import React from 'react';
import styles from './answers.module.scss';
import { getCarbonLabel } from '../../utils';

const CarbonAnswer = (props) => {
  const { answer } = props;
  const { data } = answer;

  return (
    <div className={styles.answerContainer}>
      {data?.map((item, index) => (
        <div key={`${answer.id}${index + 1}`} className={styles.answerItem}>
          <div>
            <h4>Activity {index + 1}:</h4>
          </div>
          <div className={styles.answerDataContainer}>
            {Object.keys(item.meta)
              .filter((key) => key !== 'data')
              ?.map((key) => (
                <div key={key} className={styles.answerTextItem}>
                  <span className={styles.label}>{`${getCarbonLabel(key)}: `}</span>
                  {`${item.meta[key]}`}
                </div>
              ))}
            <div key={`${data}${index + 1}`} className={styles.answerTextItem}>
              <span className={styles.label}>{'Value: '}</span>
              {item.data}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CarbonAnswer;
